var _style, _path, _rect, _rect2, _polygon, _rect3, _polygon2, _path2, _g, _defs, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLactoseIntolerance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2A384F;}\n\t.st1{fill:#B5D5E8;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#6DC8F2;}\n\t.st4{clip-path:url(#SVGID_2_);fill:none;stroke:#FDFFFF;stroke-width:6.0201;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.7,148.7,63.5,183.2,106.3,183.2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 96.6,
    y: 47.9,
    className: "st1",
    width: 18.4,
    height: 6.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 95.8,
    y: 71.1,
    className: "st1",
    width: 38.2,
    height: 83.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "115,54.7 96.6,54.6 95.8,71.1 134,71.1  "
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 71.1,
    className: "st2",
    width: 38.2,
    height: 83.2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "96.6,54.6 77.5,71.1 115.7,71.1  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.4,143.1H89.1c-4.1,0-7.4-3.3-7.4-7.4V89.8c0-4.1,3.3-7.4,7.4-7.4h15.3c4.1,0,7.4,3.3,7.4,7.4v45.9 C111.9,139.8,108.5,143.1,104.4,143.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.6,107.9c0.5,0.7,1,1.4,1.5,2.1c1.5,2.1,2.9,4.3,4.1,6.7c0.8,1.5,1.4,3,1.9,4.6c0.2,0.8,0.4,1.6,0.5,2.5 c0.2,1.7-0.2,3.4-1,4.9c-1.3,2.1-3.1,3.5-5.6,3.9c-4.2,0.8-8.4-2-9.4-6.2c-0.3-1.3-0.2-2.6,0-3.9c0.4-1.7,1-3.2,1.7-4.8 c1.2-2.6,2.7-5,4.3-7.3c0.6-0.8,1.2-1.6,1.7-2.4C96.5,108,96.6,108,96.6,107.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M106.3,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.7,148.7,63.5,183.2,106.3,183.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 42.8,
    y1: 43,
    x2: 176.6,
    y2: 164.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLactoseIntolerance);
export default __webpack_public_path__ + "static/media/Lactose_Intolerance.44a14b9efb77f84fab6614c6edc162f2.svg";
export { ForwardRef as ReactComponent };